import { GetCreditorAccountSummaryRequest } from '../types/GetCreditorAccountSummaryRequest';
import CreditorAccountSummaryApi from '../api/CreditorAccountSummaryApi';
import { CreditorAccountSummaryType } from '../types/CreditorAccountSummaryType';

export default {
  getCreditorAccountSummary: async (request: GetCreditorAccountSummaryRequest): Promise<CreditorAccountSummaryType> => {
    return await CreditorAccountSummaryApi.getCreditorAccountSummary(request);
  },
};
